import { render, staticRenderFns } from "./MaterialPreview.vue?vue&type=template&id=090af4ba"
import script from "./MaterialPreview.vue?vue&type=script&lang=js"
export * from "./MaterialPreview.vue?vue&type=script&lang=js"
import style0 from "./MaterialPreview.vue?vue&type=style&index=0&id=090af4ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports